import SpeakerRegistration from "./SpeakerRegistration";

export default SpeakerRegistration;
